import styled from '@emotion/styled';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button from '~/common/components/Button';
import { formatDateWithTime } from '~/common/util/format';

import { RowTd } from './AuditTable';

const GhostButton = styled(Button)`
  border: none;
  display: block;
  &:hover {
    background: none;
  }
`;
export function RowDetails(
  loanAction,
  userName,
  userEmail,
  modifiedDateTime,
  isShowHistoryActive,
  handleClick,
  showHistory,
) {
  return (
    <>
      <RowTd colSpan={1}>
        <b>{userName ?? 'Username Not Available'}</b>
        <br />
        {userEmail}
      </RowTd>
      <RowTd colSpan={1}>{formatDateWithTime(modifiedDateTime)}</RowTd>
      <RowTd colSpan={1}>
        {isShowHistoryActive && (
          <GhostButton
            isPrimary={false}
            onClick={handleClick}
            aria-controls={`group-${loanAction.replace(' ', '')}`}
            aria-expanded={showHistory}
          >
            {showHistory ? 'Hide' : 'Show'} History <br />
            <FontAwesomeIcon
              icon={(showHistory ? faChevronUp : faChevronDown) as IconProp}
            />
          </GhostButton>
        )}
      </RowTd>
    </>
  );
}
